import React from 'react';
import { Box, Typography, Avatar, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';
import logo from '../assets/images/pool.jpeg';

const socialLinks = [
  { path: "#", icon: <InstagramIcon sx={{ fontSize: 18 }} /> },
  { path: "#", icon: <XIcon sx={{ fontSize: 18 }} /> },
  { path: "#", icon: <WhatsAppIcon sx={{ fontSize: 18 }} /> },
  { path: "#", icon: <YouTubeIcon sx={{ fontSize: 18 }} /> },
];

const footerLinks = [
  { label: 'Privacy Policy', path: '/policies' },
  { label: 'Terms & Conditions', path: '/terms_and_conditions' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box sx={{ bgcolor: '#0d1117', color: '#fff', pt: 8, pb: 4, px: { xs: 3, md: 10 } }}>
      {/* Top Row */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { md: 'center' }, gap: 4, mb: 6 }}>
        {/* Brand */}
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
            <Avatar src={logo} sx={{ height: 38, width: 38 }} />
            <Typography sx={{ fontWeight: 800, fontSize: '1.2rem', color: '#fff' }}>SpotPool</Typography>
          </Box>
          <Typography sx={{ color: '#6b7280', fontSize: '0.9rem', maxWidth: 280, lineHeight: 1.7 }}>
            The future of pool table management. Automated, remote, effortless.
          </Typography>
        </Box>

        {/* Links */}
        <Box sx={{ display: 'flex', gap: { xs: 3, md: 6 } }}>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1.5, mb: 2 }}>Navigate</Typography>
            {['/#home', '/#about', '/#pricing', '/#faqs', '/#contact'].map((href, i) => (
              <Box key={i} sx={{ mb: 1 }}>
                <a href={href} style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.9rem' }}>
                  {['Home', 'About', 'Charges', 'FAQs', 'Contact'][i]}
                </a>
              </Box>
            ))}
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1.5, mb: 2 }}>Legal</Typography>
            {footerLinks.map(({ label, path }) => (
              <Box key={label} sx={{ mb: 1 }}>
                <Link to={path} style={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.9rem' }}>{label}</Link>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Social */}
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1.5, mb: 2 }}>Follow Us</Typography>
          <Box sx={{ display: 'flex', gap: 1.5 }}>
            {socialLinks.map(({ path, icon }, i) => (
              <Link
                key={i}
                to={path}
                style={{
                  width: 38, height: 38,
                  border: '1px solid #374151',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#9ca3af',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                }}
              >
                {icon}
              </Link>
            ))}
          </Box>
        </Box>
      </Box>

      <Divider sx={{ borderColor: '#1f2937', mb: 3 }} />

      <Typography sx={{ textAlign: 'center', color: '#4b5563', fontSize: '0.85rem' }}>
        © {currentYear} SpotPool. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
